import {
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { Subject } from 'rxjs';
import { RuleSet } from '@app/shared/condition-builder';
import { QueryService } from '@app/core/queries';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';

@Component({
  selector: 'afoone-query-builder-output',
  template: `
    <div class="container" *ngIf="this.sqlOutput" [@fadeInOut]>
      <code class="output-column" [highlight]="sqlOutput" [languages]="['SQL']">
      </code>
    </div>
  `,
  styles: [
    `
      .container {
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
        margin: 10px;
        color: #eee;
        background-color: #1c1b1b;
      }
    `,
  ],
  animations: [
    trigger('fadeInOut', [
      state(
        'void',
        style({
          opacity: 0,
        })
      ),
      transition(':enter, :leave', [animate('0.5s')]),
    ]),
  ],
})
export class QueryBuilderOutputComponent implements OnInit {
  @Input('rulesetObservable$')
  ruleset$: Subject<RuleSet>;

  protected sqlOutput: string;

  constructor(private service: QueryService) {}
  ngOnInit(): void {
    this.ruleset$.subscribe((ruleset) => {
      console.log('ruleset', ruleset);
      this.updateSQL(ruleset);
    });
  }

  private updateSQL(ruleset): void {
    this.sqlOutput = ruleset ? this.service.getSqlFromRuleset(ruleset) : '';
  }
}
